import axios from 'axios'
import { language } from '../util/language'
import { redirectToPaywall } from '../util/paywall'

const url = process.env.VUE_APP_CHECKLIST_API_URL
const token = localStorage.getItem('access_token')

const axiosInstance = axios.create({ baseURL: url })

axiosInstance.interceptors.request.use(
  (request) => {
    if (!token) throw new Error('No token provided')

    request.headers = {
      'Content-Type': 'application/json',
      'Accept-Language': language(),
      Authorization: `Bearer ${token}`,
    }

    request.timeout = 60000
    return request
  },
  async ({ response }) => {
    return Promise.reject(response)
  }
)

// hcheck refuses a company with no live subscription with 402; the paywall explains it. The rejection
// is passed through untouched so existing callers keep the error shape they already handle.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 402) redirectToPaywall()
    return Promise.reject(error)
  }
)

export const checklistApi = {
  get(endpoint, params) {
    return axiosInstance.get(endpoint, params)
  },

  post(endpoint, payload, config = {}) {
    return axiosInstance.post(endpoint, payload, config)
  },
}
